(function(document) {

    var selectors = {
        ultraListingSwiperMen: '.product-listing-4col-swiper--men',
        ultraListingSwiperWomen: '.product-listing-4col-swiper--women',
        modalVideo: '.modal-video',
        modalVideoClose: '.modal-video .icon-close',
        playVideoBtns: '.play-video',
        body: 'body',
    };
  
    var ultraListingSwiperMen = document.querySelector(selectors.ultraListingSwiperMen);
    var ultraListingSwiperWomen = document.querySelector(selectors.ultraListingSwiperWomen);
    var modalVideo = document.querySelector(selectors.modalVideo);
    var modalVideoClose = document.querySelector(selectors.modalVideoClose);
    var playVideoBtns = document.querySelectorAll(selectors.playVideoBtns);
    var body = document.querySelector(selectors.body);
  
    var ultraListing_SwiperMen = ""
    var ultraListing_SwiperWomen = ""

    window.onresize = function(event) {
        swiperizeListingUltra()
    };

    swiperizeListingUltra()

    function swiperizeListingUltra() {
        if ($(window).width() < 769 ) {
    
            ultraListing_SwiperMen = new Swiper(ultraListingSwiperMen, {
                slidesPerView: 1.3,
            });
            ultraListing_SwiperWomen = new Swiper(ultraListingSwiperWomen, {
                slidesPerView: 1.3,
            });
        }
    }

    if (playVideoBtns) {
        playVideoBtns.forEach(function(playVideoBtn) {
            playVideoBtn.addEventListener("click", function(){
                modalVideo.classList.remove("hide")
                body.appendChild(modalVideo)
                var attrVid_toPlay = playVideoBtn.getAttribute("attr-video")
                var videosModal = modalVideo.querySelectorAll('.video-single-modal')
                videosModal.forEach(function(videoModal) {
                    var attrVid_Playing = videoModal.getAttribute("attr-video")
                    videoModal.classList.remove("show")
                    if (attrVid_toPlay == attrVid_Playing) {
                        videoModal.classList.add("show")
                        // videoModal.querySelector("video").play()
                    }
                })
                modalVideoClose.addEventListener("click", function(){
                    videosModal.forEach(function(videoModal) {
                        // videoModal.querySelector("video").pause()
                        videoModal.classList.remove("show")
                    })
                    modalVideo.classList.add("hide")
                })
            })
        })
    }
    


})(document);
  

    